export const redirectTo = (href: string, ignoreLocalHost: boolean = false) => {
    if (ignoreLocalHost || window.location.hostname !== 'localhost') {
        window.location.href = href;
    }
};
